'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.blockProductguide = twentyninetimes.blockProductguide || function () {

	function init() {
		const productguide = document.getElementById('productguide');

		if ( productguide ) {
      mobileFilterToggle(productguide);
		}
	}

  function mobileFilterToggle(productguide) {
    var body = document.body;

    productguide.addEventListener('click', (e) => {
      if (!e.target.classList.contains('js-toggle-filter'))
        return;

      e.stopPropagation();

      var filterContainer = productguide.querySelector('.filter-container');

      if ( !body.classList.contains('mobile-filter-open') ) {
        // Disable scrolling
        body.classList.add('no-scroll');
        bodyScrollLock.disableBodyScroll(filterContainer);

        body.classList.add('mobile-filter-open');
      } else {
        body.classList.remove('mobile-filter-open');

        // Re-activate scrolling
        body.classList.remove('no-scroll');
        bodyScrollLock.enableBodyScroll(filterContainer);
      }
    });
  }

  return {
		init : init
	};

}();